import { takeEvery } from 'redux-saga/effects';

import shiftPolicyEventSaga, { action as shiftPolicyEventSagaAction } from './getShiftFacilityPolicy';

export default () => function* () {
  yield takeEvery(shiftPolicyEventSagaAction, shiftPolicyEventSaga);
};
